import { render, staticRenderFns } from "./ExpressionBuilder.vue?vue&type=template&id=506dc984&scoped=true&"
import script from "./ExpressionBuilder.vue?vue&type=script&lang=js&"
export * from "./ExpressionBuilder.vue?vue&type=script&lang=js&"
import style0 from "./ExpressionBuilder.vue?vue&type=style&index=0&id=506dc984&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506dc984",
  null
  
)

export default component.exports